module.exports = __webpack_public_path__ + "img/step-icon-signature.5f2365e0.svg";